// LIBRERIE
import { useTranslation } from "react-i18next";

const Presentation: React.FC = () => {
    const { t } = useTranslation();

    return (
        <section id="presentation" className="space-ptb">
            <div className="container-fluid">
                <div className="row align-items-center">
                    <div className="col-12 col-xl-6">
                        <div className="row justify-content-around mb-4 mb-xl-0">
                            <div className="col-12 col-lg-5 col-xl-8 special-col pl-xl-5">
                                <h2 dangerouslySetInnerHTML={{ __html: t('homePage.presentation.title') as string }} />
                                <p>{t('homePage.presentation.para1')}</p>
                            </div>
                            <div className="col-12 col-lg-5 col-xl-12 text-center">
                                <img className="img-fluid img-border" src="/assets/images/inHome/salone.webp" alt={t('homePage.presentation.altImg') as string} />
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-xl-6 d-lg-flex">
                        <div className="mr-lg-3">
                            <p dangerouslySetInnerHTML={{ __html: t('homePage.presentation.para2') as string }} />
                            <p dangerouslySetInnerHTML={{ __html: t('homePage.presentation.para3') as string }} />
                            <p dangerouslySetInnerHTML={{ __html: t('homePage.presentation.para4') as string }} />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
export default Presentation;